import '../scss/layout.scss';
import '../scss/responsive.scss';

import '../images/email_logo.gif';
import '../images/email_bottom.jpg';